import { generateRequest } from './request.js';
import { AveRequestEvents } from '../events.js';
/**
 * Render the current view with the given settings.
 * The images are available via a GET endpoint or from local disk.
 *
 * Limitations:
 * - Request is always possible.
 * - There is a Maximum Resolution of 16k.
 * - imageWidth * oversampling <= 15360 !
 * - imageHeight * oversampling <= 8640 !
 *
 * Notes:
 * - For detailed interaction spots response documentation, see AVEGetInteractionSpots.
 *
 * ```
 * Example:
 * [{
 *   "meta": {
 *     "name": "AVERenderImage",
 *     "type": "REQUEST"
 *   },
 *   "data" : {
 *     "imageName" : <string>,
 *     "format" : <string>,
 *     "imageWidth" : <int>,
 *     "imageHeight" : <int>,
 *     "oversampling" : <int>,
 *     "transparentBackground ": <bool>,
 *     "withGroundShadow": <bool>
 *     "RenderQuality":
 *     {
 *       "Shadows": <Enum>,
 *       "AmbientOcclusion": <Enum>,
 *       "Reflections": <Enum>,
 *       "GlobalIllumination": <Enum>
 *     },
 *     "GetRenderTimings": <Enum>,
 *     "InteractionSpots": <bool>,
 *     "S3StorageName": <string>
 *   }
 * }]
 * ```
 */
export function generateRenderImageRequest({ imageName, format, imageWidth, imageHeight, oversampling, transparentBackground, withGroundShadow, renderQuality, getRenderTimings, interactionSpots, s3StorageName, messageId }) {
    return generateRequest({
        messageId,
        name: AveRequestEvents.AVERenderImage,
        data: {
            imageName,
            format,
            imageWidth,
            imageHeight,
            oversampling,
            transparentBackground,
            withGroundShadow,
            RenderQuality: renderQuality,
            GetRenderTimings: getRenderTimings,
            InteractionSpots: interactionSpots,
            S3StorageName: s3StorageName
        }
    });
}
/**
 * This command reads the requested image either from the cache or from disk if not already cached.
 *
 * Limitations:
 * - Images can only be fetched relative from the predefined RenderImagePath.
 *
 * Notes:
 * - It is possible to retrieve images from subfolders that are relative to the RenderImagePath. If the images are located in the RenderImagePath the name for this request is sufficient.
 * - Returns an array of bytes. Simply saving this array to a file with .png extension yields a valid image
 *
 * Example:
 * ```
 * {
 *   "path": "AVERenderImage_1611138553.PNG"
 * }
 * ```
 */
export function generateGetImageRequest({ messageId, path }) {
    return generateRequest({
        messageId,
        name: AveRequestEvents.AVEGetImage,
        data: {
            path
        }
    });
}
//# sourceMappingURL=rendering.js.map